export const isExpectedHttpStatus = (status: number | undefined, matchStatus: number): boolean => status === matchStatus

export const isSuccessfulHttpStatus = (status: number | undefined): boolean => status !== undefined && status >= 200 && status < 300

export const isNetworkError = (status: number): boolean => isExpectedHttpStatus(status, 502) || isExpectedHttpStatus(status, 503) || isExpectedHttpStatus(status, 504)

const appName = 'Portal'

export const defaultMetaHeaders = {
  'User-Agent': `Swagger ${appName}`,
  'X-Source': appName,
} as const